import { useContext } from 'react';

import { CompleteGoalContext } from './complete-goal-context';

export const useCompleteGoal = () => {
  const { onCompleteDialog } = useContext(CompleteGoalContext);

  return onCompleteDialog;
};
